import React from "react";

const BothyList = ({ bothies, onSelect }) => (
  <div className="bothy-list">
    {bothies.map(bothy => {
      const hasNearest =
        bothy.closestEntry &&
        bothy.closestDistance !== undefined &&
        bothy.closestDistance !== null;

      const formattedNearest = hasNearest
        ? `${bothy.closestEntry} (${bothy.closestDistance}km)`
        : null;

      return (
        <button
          key={bothy.id}
          className="bothy-card"
          onClick={() => onSelect(bothy)}
          onKeyDown={event => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              onSelect(bothy);
            }
          }}
          type="button"
        >
          <div className="bothy-card__row">
            <h4>{bothy.name}</h4>
          </div>
          <div className="bothy-card__meta">
            <span>Bortle {bothy.bortleClass || "?"}</span>
            <span>Elevation {bothy.elevation}m</span>
            {formattedNearest && <span>Nearest: {formattedNearest}</span>}
          </div>
          {Array.isArray(bothy.bothyFeatures) && bothy.bothyFeatures.length > 0 && (
            <div className="chip-row">
              {bothy.bothyFeatures.slice(0, 3).map(feature => (
                <span key={feature} className="chip">
                  {feature}
                </span>
              ))}
              {bothy.bothyFeatures.length > 3 && (
                <span className="chip chip--muted">
                  +{bothy.bothyFeatures.length - 3} more
                </span>
              )}
            </div>
          )}
        </button>
      );
    })}

    {bothies.length === 0 && (
      <div className="empty-state">
        <p className="eyebrow">No matches</p>
        <p className="lede">
          Loosen your filters or search for a neighbouring bothy.
        </p>
      </div>
    )}
  </div>
);

export default BothyList;
